import { useEffect, useRef } from 'react'
import { authentication, app } from '@microsoft/teams-js'

import { msalInstance } from './MSALConfig'

const AZURE_BACKEND_CLIENT_ID = import.meta.env.VITE_AZURE_BACKEND_CLIENT_ID
const SCOPES = [`${AZURE_BACKEND_CLIENT_ID}/.default`]
const REDIRECT_URI = `${window.location.origin}/login/teams-auth`

function getErrorMessage(error: unknown) {
  return error instanceof Error ? error.message : String(error)
}

const TeamsMicrosoftAuth: React.FC = () => {
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return
    started.current = true

    async function authenticate() {
      try {
        await app.initialize()
        await msalInstance.initialize()

        const redirectResult = await msalInstance.handleRedirectPromise()
        if (redirectResult?.accessToken) {
          authentication.notifySuccess(redirectResult.accessToken)
          return
        }

        const account = msalInstance.getAllAccounts()[0]
        if (account) {
          const silentResult = await msalInstance.acquireTokenSilent({
            account,
            scopes: SCOPES,
            redirectUri: REDIRECT_URI,
          })
          authentication.notifySuccess(silentResult.accessToken)
          return
        }

        await msalInstance.loginRedirect({
          scopes: SCOPES,
          redirectUri: REDIRECT_URI,
        })
      } catch (error) {
        authentication.notifyFailure(getErrorMessage(error))
      }
    }

    void authenticate()
  }, [])

  return null
}

export default TeamsMicrosoftAuth
